export const adminSideBar = {
  dashboard: {
    menuName: "Dashboard",
    menuIcon: "fab fa-product-hunt",
    route: "/adminDashboard",
  },
  adminSettings: {
    menuName: "Admin Settings",
    menuIcon: "fas fa-briefcase",
    route: "/companylocation",
  },
  project: {
    menuName: "Project Board",
    menuIcon: "fab fa-product-hunt",
    subMenu: [
      {
        subMenuName: "Project List",
        icon: "fas fab fa-product-hunt",
        route: "/listProjects",
      },
      {
        subMenuName: "Project's Work Status",
        icon: "fas fab fa-product-hunt",
        // route: "/viewtaskManagment",
        route: "/ModernViewTaskManagement",
      },
      {
        subMenuName: "Task Board",
        icon: "fas fab fa-product-hunt",
        route: "/taskBoard/54",
      },
    ],
  },
  employeeSettings: {
    menuName: "Employee Settings",
    menuIcon: "fas fa-user-tie",
    subMenu: [
      {
        subMenuName: "All Employee",
        icon: "fas fab fa-product-hunt",
        route: "/emplist",
      },
      {
        subMenuName: "Appraisal",
        icon: "fas fab fa-product-hunt",
        route: "/appraisal",
      },
      {
        subMenuName: "Assign Rewards",
        icon: "fas fab fa-product-hunt",
        route: "/assignRewards",
      },
      {
        subMenuName: "Process Rewards",
        icon: "fas fab fa-product-hunt",
        route: "/processRewards",
      },
      {
        subMenuName: "Excel Import",
        icon: "fas fab fa-product-hunt",
        route: "/EmployeeExcelImport",
      },
      // {
      //   subMenuName: "Asset Excel Import",
      //   icon: "fas fab fa-product-hunt",
      //   route: "/AssetExcelImport",
      // },
      // {
      //   subMenuName: "Calendar Year",
      //   icon: "fas fab fa-product-hunt",
      //   route: "/calendaryear",
      // },
    ],
  },
  leaveManagement: {
    menuName: "Leave Management",
    menuIcon: "fas fa-user-tie",
    subMenu: [
      {
        subMenuName: "Calendar Year",
        icon: "fas fab fa-product-hunt",
        route: "/calendaryear",
      },
      {
        subMenuName: "Leave/Duty Type",
        icon: "fas fab fa-product-hunt",
        route: "/leavetype",
      },
      // {
      //   subMenuName: "Mail Configuration",
      //   icon: "fas fab fa-product-hunt",
      //   route: "/configuremail",
      // },
      {
        subMenuName: "Mail Configuration",
        icon: "fas fab fa-product-hunt",
        route: "/configuremailforleave",
      },
      {
        subMenuName: "Assign Leave/Duty",
        icon: "fas fab fa-product-hunt",
        route: "/assignleave",
      },
      {
        subMenuName: "Holiday Calendar",
        icon: "fas fab fa-product-hunt",
        route: "/holidaycalender",
      },
      {
        subMenuName: "Shifts",
        icon: "fas fab fa-product-hunt",
        route: "/shifts",
      },
      {
            subMenuName: "Year End",
            icon: "fab fa-product-hunt",
            route: "/yearendprocess",
          },
          {
            subMenuName: "Leave Summary",
            icon: "fas fab fa-product-hunt",
            route: "/leavesummarylist",
          },
          {
            subMenuName: "Leave Calendar",
            icon: "fas fab fa-product-hunt",
            route: "/LeaveCalendar",
          },
      
    ],
  },
  payRoll: {
    menuName: "Pay Roll",
    menuIcon: "fas fa-user-tie",
    subMenu: [
      
      {
        subMenuName: "Pay Roll Items",
        icon: "fas fab fa-product-hunt",
        route: "/payRollItems",
      },
      {
        subMenuName: "Employee salary",
        icon: "fas fab fa-product-hunt",
        route: "/employeeSalary",
      },
      {
        subMenuName: "Process Salary",
        icon: "fas fab fa-product-hunt",
        route: "/processSalary",
      },
      {
        subMenuName: "Salary Report",
        icon: "fas fab fa-product-hunt",
        route: "/salaryReport",
      },
      {
        subMenuName: "Privilege Leave",
        icon: "fas fab fa-product-hunt",
        route: "/plReport",
      },
    ],
  },
  finance: {
    menuName: "Finance",
    menuIcon: "fas fa-user-tie",
    subMenu: [
      {
        subMenuName: "Petty Cash",
        icon: "fas fab fa-product-hunt",
        route: "/pettyCash",
      },
      {
        subMenuName: "Gift Voucher",
        icon: "fas fab fa-product-hunt",
        route: "/giftVoucher",
      },
      {
        subMenuName: "Invoice",
        icon: "fas fab fa-product-hunt",
        route: "/invoice",
      },
    ],
  },
  helpdesk: {
    menuName: "Help Desk",
    menuIcon: "fas fa-user-tie",
    subMenu: [
      {
        subMenuName: "Help Desk Settings",
        icon: "fas fab fa-product-hunt",
        route: "/HelpDeskSettings",
      },
      {
        subMenuName: "Time Sheet Unlock",
        icon: "fas fab fa-product-hunt",
        route: "/tasksheetUnlock",
      },
      {
        subMenuName: "Admin All Ticket",
        icon: "fas fab fa-product-hunt",
        route: "/AdminListAllTickets",
      },
      {
        subMenuName: "All Ticket",
        icon: "fas fab fa-product-hunt",
        route: "/ListAllTicktes",
      },
    ],
  },
  // reports: {
  //   menuName: "Report Menu",
  //   menuIcon: "fas fa-user-tie",
  //   subMenu: [
  //     {
  //     subMenuName: "All Reports",
  //     icon: "fas fab fa-product-hunt",
  //     route: "/ReportSummary",
  //     },
  //   ],
  // },
   reports:{
      menuName: "Reports",
      menuIcon: "fab fa-product-hunt",
      route: "/ReportSummary",
    },
  
  yearendprocess:{
      menuName: "Year End",
      menuIcon: "fab fa-product-hunt",
      route: "/yearendprocess",
    }
 
};
